import '../styles.scss';
import './styles.scss';
import React, { useState, useEffect } from 'react';
import DateUtils from '../../../services/DateUtils';
import SessionDescription from '../components/SessionDescription';
import SessionSingleControls from '../components/SessionSingleControls';
import { fetchData, extractAttendance } from './state.jsx';
import { $state, $stateParams } from '../../../router';
import { GECKO_CONSTS, GeckoBtn } from '@geckolabs/gecko-react-ui';

export const RsvpLiteSessionPage = ({session, sessionTimes, bookedAttendance, account}) => {
    const [attendance, setAttendance] = useState(bookedAttendance);

    useEffect(() => {
        // Set account timeFormat
        DateUtils.setTimeFormatFromAccount(account.time_format);
        // Set locale for date formating
        DateUtils.setLocale();
    }, []);

    const updateDataCb = () => {
        return fetchData($stateParams.account_uuid, $stateParams.contact_uuid, $stateParams.event_id).then(({contact, attendances}) => {
            const sessionTimeIds         = sessionTimes.map(sessionTime => sessionTime.id);
            const sessionTimeAttendances = attendances.filter(attendance => sessionTimeIds.includes(attendance.event_id));
            const sessionTimeAttendance  = extractAttendance(sessionTimeAttendances, sessionTimes);
            const sessionAttendance      = attendances.find(attendance => attendance.event_id === session.id);
            const previousAttendances    = sessionTimeAttendances.filter(attendance => attendance.id !== sessionTimeAttendance.id);

            setAttendance(sessionTimeAttendance);
            
            return {
                contact,
                currentAttendances: [sessionAttendance, sessionTimeAttendance],
                previousAttendances,
            };
        });
    };

    return (
        <div className="rsvp-lite-container">
            <div className="session-single">

                <div className="rsvp-lite-card">
                    <SessionDescription {...{
                        session, 
                        attendance
                    }} />
                </div>

                <SessionSingleControls {...{
                    session, 
                    sessionTimes, 
                    attendance, 
                    updateDataCb
                }} />

                <div className="rsvp-lite-card">
                    <GeckoBtn {...{
                        name: 'Back to Sessions',
                        type: GECKO_CONSTS.BTN_TYPE_DEFAULT,
                        icon: 'chevron-left',
                        handler: () => $state.go('rsvp-lite-manage-sessions', $stateParams)
                    }} />
                </div>
            </div>
        </div>
    );
}

export default RsvpLiteSessionPage;